import {AfterViewInit, Component, OnInit} from '@angular/core';
import {MonitoringService} from '../service/utility/monitoring/monitoring.service';

import {environment} from '../../environments/environment';
// import {environment} from '../../environments/environment.prod';

declare function GetHorses(obj: any): any;
declare function UpdateHorses(obj: any): any;
declare function GetHorsesBetsList(obj: any): any;

@Component({
  selector: 'app-test',
  templateUrl: './test.component.html',
  styleUrls: ['./test.component.scss']
})
export class TestComponent implements OnInit, AfterViewInit {
  enviromentStaging = environment;
  public urlSite = 'http://localhost:4200/';
  public cID = 'B55E93CF-E170-4732-8D3A-0E7F57271B93';
  public sID = '';
  public type = 'bet';

  constructor(
      private appInsightsService: MonitoringService,
  ) {
    if (localStorage.getItem('userTestcID')) {
      this.cID = localStorage.getItem('userTestcID');
    }
    if (localStorage.getItem('userTestType')) {
      this.type = localStorage.getItem('userTestType');
    }
    if (localStorage.getItem('userTestSID')) {
      this.sID = localStorage.getItem('userTestSID');
    }
  }

  ngOnInit(): void {
    // TODO salavre il CID in unì coockie
    this.changeFrame();
  }

  getCidByEnv(env: any): any{
    return Object.keys(env);
  }

  changeCid(cID?): void {
    if (cID) {
      this.cID = cID.value;
      localStorage.setItem('userTestcID', cID.value);
    }
    GetHorses({
      urlSite: 'http://localhost:4200/',
      // Staging cID
      cID: this.cID,
      sID: this.sID, // token di test ffffffff-ffff-ffff-ffff-ffffffffffff
      imageshome: [
        // {
        // url: 'https://www.opplastore.it/wp-content/uploads/2019/04/gioco-per-il-cavallo_fb.jpg',
        // link: 'https://areaprivata.sisal.it/loginJwt/'
        // }
      ],
      imagescart: [
        // {
        //   link: 'https://c-eq.niceshops.com/upload/image/banner/original/default/7270_ac3f5c95.jpg',
        //   url: 'https://c-eq.niceshops.com/upload/image/banner/original/default/7270_ac3f5c95.jpg'
        // }, {
        //   link: 'https://www.opplastore.it/wp-content/uploads/2019/04/gioco-per-il-cavallo_fb.jpg',
        //   url: 'https://www.opplastore.it/wp-content/uploads/2019/04/gioco-per-il-cavallo_fb.jpg'
        // },
        // {
        //   type: 'link',
        //   source: 'https://www.google.it',
        //   url: 'https://www.cavallotop.com/wp-content/uploads/2019/07/sangue-caldo-freddo-e-misto.jpg'
        // },
        // {
        //   link: 'javascript:betSuccess',
        //   url: 'https://images2.corriereobjects.it/methode_image/2018/05/17/Scienze/Foto%20Gallery/vanessasalvaticiuffini_03_MGZOOM.jpg'
        // },
        {
          type: 'link',
          source: 'javascript:prova',
          url: 'https://encrypted-tbn2.gstatic.com/images?q=tbn:ANd9GcRMLfWB9kgv51uw-DvMbTh0UkHq5Mb5dBa7JjdNJ9Fh6JBNdzJNROtBzR-e9Ola6SapLC1Mk79ps229eJl7ysu6_A'
        }
      ],
      classTopMobile : 'navbar',
      // tabMenu:
      //   [{
      //     index: 'nation',
      //     device: 'desktop'
      //   },
      //     {
      //       index: 'last',
      //       device: 'mobile'
      //     }],
      OnCompleteBet: 'betSuccess',
      OnClickBetBtn: 'betLogin',
      // TrackGA: '',
      // videoenabled: false,
      // showticketlisticon: true,
      // hidefullstats: false,
      // customCss: 'http://www.io.io',
      // playvideo: true,
      // disableaudio: '',
      disableaudio: true,
      // meeting: 'GBR-kempton',
      // raceid: '1216718',
      // bet: 'TOT',
      // type: 'GL',
      language: 'it-IT',
      // terminalTag: 134
      betConfirm: true,
      // localOrigin: '*',
      // coverVideo: 'https://www.online-tech-tips.com/wp-content/uploads/2019/08/video-not-found.png',
      racesMenuMobile: true
    });
  }

  changeSid(sID): void {
    if (sID) {
      this.sID = sID;
      localStorage.setItem('userTestSID', sID);
    }
    UpdateHorses({
      // Staging cID
      cID: this.cID,
      sID: this.sID,
    });
  }

  logOut() {
    this.sID = '';
    localStorage.setItem('userTestSID', '');
    UpdateHorses({
      // Staging cID
      cID: this.cID,
      sID: this.sID,
    });
  }

  changeFrame(type?): void {
    if (type) {
      this.type = type;
      localStorage.setItem('userTestType', type);
    }
    if (this.type === 'bet') {
      this.changeCid();
    }
    if (this.type === 'ticket') {
      GetHorsesBetsList({
        urlSite: this.urlSite,
        cID: this.cID,
        sID: this.sID,
        // customCss: 'https://www.io.io/pippo.css',
      });
    }
  }

  ngAfterViewInit(): void {

  }

}
